import { render, staticRenderFns } from "./MPopupUploadLogo.vue?vue&type=template&id=0bd98d62&"
import script from "./MPopupUploadLogo.vue?vue&type=script&lang=ts&"
export * from "./MPopupUploadLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports